import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Box,
  Collapse,
  CircularProgress,
} from "@material-ui/core";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import { getAuditLogByModel } from "../../../reducer/auditLog/action";

const FIELD_LABEL_MAP = {
  title: "Tên sách",
  numOfMember: "Số lượng tác giả",
  publisher: "Nhà xuất bản",
  year: "Năm xuất bản",
  pageNumber: "Số trang",
  isbn: "ISBN",
  timeResearchDetailCode: "Loại công trình",
  soLanTaiBan: "Số lần tái bản",
  giayPhepXuatBan: "Giấy phép xuất bản",
  language: "Ngôn ngữ",
  link: "Link",
  thuocDeTai: "Thuộc sản phẩm của đề tài",
  note: "Ghi chú",
  acceptedDay: "Ngày/Tháng/Năm xuất bản",
  submissionDay: "Ngày/Tháng/Năm nộp",
  issueAt: "Ngày/Tháng/Năm phát hành",
  dashboardYear: "Năm hiển thị",
  purposeId: "Mục đích",
  accepted: "Trạng thái duyệt",
  locked: "Trạng thái khóa",
};
const FIELD_VALUE_MAP = {
  language: { vietnamese: "Tiếng Việt", english: "Tiếng Anh", other: "Khác" },
  accepted: { true: "Đã được duyệt", false: "Chưa được duyệt" },
  locked: {
    kpi: "Đã khóa KPI",
    reward: "Đã khóa thưởng",
    timeResearch: "Đã khóa giờ nghiên cứu",
    false: "Chưa khóa",
    null: "Chưa khóa",
  },
};
function getFieldLabel(key) {
  return FIELD_LABEL_MAP[key] || key;
}
function getFieldValue(key, val) {
  if (val === null || val === undefined) return <em style={{ color: "#bbb" }}>—</em>;
  const valueMap = FIELD_VALUE_MAP[key];
  if (valueMap) {
    const mapped = valueMap[String(val)];
    if (mapped !== undefined) return mapped;
  }
  if (typeof val === "boolean") return val ? "Có" : "Không";
  if (Array.isArray(val)) return val.join(", ");
  return String(val);
}
const ACTION_TYPE_LABEL = {
  ADD: { label: "Thêm mới", color: "#4caf50" },
  EDIT: { label: "Chỉnh sửa", color: "#2196f3" },
  DELETE: { label: "Xóa", color: "#f44336" },
  APPROVE: { label: "Duyệt", color: "#009688" },
  REJECT: { label: "Từ chối", color: "#ff5722" },
  LOCK: { label: "Khóa", color: "#9e9e9e" },
  UNLOCK: { label: "Mở khóa", color: "#795548" },
  STATUS_CHANGE: { label: "Đổi trạng thái", color: "#ff9800" },
  RECALCULATE: { label: "Tính lại", color: "#673ab7" },
};
function formatDate(dateStr) {
  if (!dateStr) return "N/A";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
function parseData(dataStr) {
  if (!dataStr) return null;
  try {
    return typeof dataStr === "string" ? JSON.parse(dataStr) : dataStr;
  } catch {
    return dataStr;
  }
}
function DiffPanel({ historyType, dataStr }) {
  const data = parseData(dataStr);
  if (!data)
    return (
      <Typography variant="body2" color="textSecondary">
        Không có dữ liệu chi tiết.
      </Typography>
    );
  if (historyType === "EDIT" && data.before && data.after) {
    const fields = Object.keys({ ...data.before, ...data.after }).filter((field) => field in FIELD_LABEL_MAP);
    return (
      <Box style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#f5f5f5" }}>
              <th style={{ padding: "6px 12px", textAlign: "left", borderBottom: "1px solid #e0e0e0", width: "30%" }}>
                Trường
              </th>
              <th
                style={{
                  padding: "6px 12px",
                  textAlign: "left",
                  borderBottom: "1px solid #e0e0e0",
                  width: "35%",
                  color: "#f44336",
                }}
              >
                Trước
              </th>
              <th
                style={{
                  padding: "6px 12px",
                  textAlign: "left",
                  borderBottom: "1px solid #e0e0e0",
                  width: "35%",
                  color: "#4caf50",
                }}
              >
                Sau
              </th>
            </tr>
          </thead>
          <tbody>
            {fields.map((field) => (
              <tr key={field} style={{ borderBottom: "1px solid #f0f0f0" }}>
                <td style={{ padding: "5px 12px", fontWeight: 500 }}>{getFieldLabel(field)}</td>
                <td style={{ padding: "5px 12px", color: "#c62828", wordBreak: "break-all" }}>
                  {getFieldValue(field, data.before[field])}
                </td>
                <td style={{ padding: "5px 12px", color: "#2e7d32", wordBreak: "break-all" }}>
                  {getFieldValue(field, data.after[field])}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    );
  }
  if (typeof data === "object" && !Array.isArray(data)) {
    const fields = Object.keys(data).filter((field) => field in FIELD_LABEL_MAP);
    if (fields.length > 0) {
      return (
        <Box style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "#f5f5f5" }}>
                <th style={{ padding: "6px 12px", textAlign: "left", borderBottom: "1px solid #e0e0e0", width: "40%" }}>
                  Trường
                </th>
                <th style={{ padding: "6px 12px", textAlign: "left", borderBottom: "1px solid #e0e0e0", width: "60%" }}>
                  Giá trị
                </th>
              </tr>
            </thead>
            <tbody>
              {fields.map((field) => (
                <tr key={field} style={{ borderBottom: "1px solid #f0f0f0" }}>
                  <td style={{ padding: "5px 12px", fontWeight: 500 }}>{getFieldLabel(field)}</td>
                  <td style={{ padding: "5px 12px", wordBreak: "break-all" }}>{getFieldValue(field, data[field])}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      );
    }
  }
  return (
    <Typography variant="body2" color="textSecondary">
      Không có dữ liệu chi tiết.
    </Typography>
  );
}
function HistoryRow({ row, index }) {
  const [expanded, setExpanded] = useState(false);
  const typeInfo = ACTION_TYPE_LABEL[row.type] || { label: row.type, color: "#607d8b" };
  const submitter = row.updatedBy?.name || row.updatedBy?.email || row.submitterName || row.submitterEmail || "N/A";
  const hasDetail = !!row.data && (row.type === "ADD" || row.type === "EDIT" || row.type === "DELETE");
  return (
    <>
      <tr
        style={{
          borderBottom: expanded ? "none" : "1px solid #f0f0f0",
          cursor: hasDetail ? "pointer" : "default",
          background: expanded ? "#f9fbe7" : "transparent",
        }}
        onClick={() => hasDetail && setExpanded((v) => !v)}
      >
        <td style={{ padding: "8px 12px", width: 48, textAlign: "center", color: "#888", fontSize: 13 }}>
          {index + 1}
        </td>
        <td style={{ padding: "8px 12px", width: 140 }}>
          <span
            style={{
              display: "inline-block",
              padding: "2px 10px",
              borderRadius: 12,
              background: typeInfo.color + "22",
              color: typeInfo.color,
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {typeInfo.label}
          </span>
        </td>
        <td style={{ padding: "8px 12px", fontSize: 13 }}>{submitter}</td>
        <td style={{ padding: "8px 12px", fontSize: 13, whiteSpace: "nowrap" }}>{formatDate(row.createdAt)}</td>
        <td style={{ padding: "8px 12px", textAlign: "center", width: 48 }}>
          {hasDetail ? (
            expanded ? (
              <ExpandLess style={{ fontSize: 18, color: "#888" }} />
            ) : (
              <ExpandMore style={{ fontSize: 18, color: "#888" }} />
            )
          ) : null}
        </td>
      </tr>
      {hasDetail && (
        <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
          <td colSpan={5} style={{ padding: 0 }}>
            <Collapse in={expanded} unmountOnExit>
              <Box style={{ padding: "8px 16px 12px 24px" }}>
                <DiffPanel historyType={row.type} dataStr={row.data} />
              </Box>
            </Collapse>
          </td>
        </tr>
      )}
    </>
  );
}
function MonographHistoryModal(props) {
  const { open, row, onClose, list: rawList, isFetching, getAuditLogByModel } = props;
  const list = Array.isArray(rawList) ? rawList : [];
  useEffect(() => {
    if (open && row?.id) getAuditLogByModel("monograph", row.id);
  }, [open, row?.id]);
  return (
    <Dialog
      fullWidth
      keepMounted
      maxWidth={false}
      open={open}
      onClose={onClose}
      disableBackdropClick
      PaperProps={{
        style: {
          width: "calc(100vw - 240px)",
          height: "100vh",
          maxWidth: "calc(100vw - 240px)",
          maxHeight: "100vh",
          margin: "0 0 0 240px",
        },
      }}
    >
      <DialogTitle
        disableTypography
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 32px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Button
          variant="outlined"
          color="secondary"
          onClick={onClose}
          style={{ padding: "8px 24px", fontSize: "15px", fontWeight: 500, borderWidth: 2 }}
        >
          Huỷ
        </Button>
        <Box style={{ textAlign: "right" }}>
          <Typography variant="h5" style={{ fontWeight: 600 }}>
            Lịch sử chỉnh sửa
          </Typography>
          {row?.title && (
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginTop: 4, fontWeight: 700, fontStyle: "italic" }}
            >
              {row.title}
            </Typography>
          )}
        </Box>
      </DialogTitle>
      <DialogContent style={{ padding: 0, overflowY: "auto", flex: 1 }}>
        {isFetching ? (
          <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
            <CircularProgress size={32} />
          </Box>
        ) : list.length === 0 ? (
          <Box style={{ textAlign: "center", padding: 48, color: "#aaa" }}>
            <Typography variant="body1">Chưa có lịch sử chỉnh sửa.</Typography>
          </Box>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f5f5f5", borderBottom: "2px solid #e0e0e0" }}>
                <th style={{ padding: "10px 12px", textAlign: "center", fontSize: 13, fontWeight: 600, width: 48 }}>
                  STT
                </th>
                <th style={{ padding: "10px 12px", textAlign: "left", fontSize: 13, fontWeight: 600, width: 140 }}>
                  Loại thao tác
                </th>
                <th style={{ padding: "10px 12px", textAlign: "left", fontSize: 13, fontWeight: 600 }}>
                  Người thực hiện
                </th>
                <th
                  style={{
                    padding: "10px 12px",
                    textAlign: "left",
                    fontSize: 13,
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  Thời gian
                </th>
                <th
                  style={{ padding: "10px 12px", textAlign: "center", fontSize: 13, fontWeight: 600, width: 48 }}
                ></th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, idx) => (
                <HistoryRow key={item.id || idx} row={item} index={idx} />
              ))}
            </tbody>
          </table>
        )}
      </DialogContent>
    </Dialog>
  );
}
const mapStateToProps = (state) => ({
  list: select(state, "auditLogReducer", "list"),
  isFetching: select(state, "auditLogReducer", "isFetching"),
});
const mapDispatchToProps = (dispatch) => ({
  getAuditLogByModel: (modelType, modelId) => dispatch(getAuditLogByModel(modelType, modelId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(toJs(MonographHistoryModal));

